// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"ecf63e90","239":"60050c20","398":"e7cb68f2","417":"2835d171","538":"e57b47fa","596":"332b5f80","824":"7dad02dd","880":"b9f3d864"}[chunkId] + ".chunk.js";
};